<template>
  <v-row class="fill-height">
    <v-col>
      <v-sheet height="64">
        <v-toolbar flat color="white">
          <!-- <v-btn color="primary" dark @click.stop="dialog = true">
            Pesan Layanan
          </v-btn> -->
          <v-btn outlined class="ml-4" @click="setToday">
            Hari ini
          </v-btn>
          <v-btn v-if="type === 'month'" fab text small @click="prev">
            <v-icon small>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn v-if="type === 'month'" fab text small @click="next">
            <v-icon small>mdi-chevron-right</v-icon>
          </v-btn>

          <v-toolbar-title class="ml-4">{{ title }}</v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-menu bottom right>

            <template v-slot:activator="{ on }">
              <v-btn outlined v-on="on">
                <span>{{ typeToLabel[type] }}</span>
                <v-icon right>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="type = 'day'">
                <v-list-item-title>Day</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'week'">
                <v-list-item-title>Week</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'month'">
                <v-list-item-title>Month</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
      </v-sheet>

      <v-dialog v-model="dialog" max-width="500">
        <v-card>
          <v-container>
            <v-form @submit.prevent="addEvent">
              <v-row align="center">
                <v-col class="d-flex" cols="12" sm="6">
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="inputStart"
                        label="Tanggal Mulai"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="inputStart" @change="[onCekJadwal(), inputEnd = inputStart]" @input="menu = false"></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col class="d-flex" cols="12" sm="6">
                  <v-select :items="jamItemsStart" v-model="startJam" @change="onCekJadwal" label="Jam"></v-select>
                </v-col>

                <v-col class="d-flex" cols="12" sm="6">
                  <v-menu
                    v-model="menuFinish"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="inputEnd"
                        label="Tanggal Selesai"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="inputEnd" @change="onCekJadwal" @input="menuFinish = false"></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col class="d-flex" cols="12" sm="6">
                  <v-select :items="jamItemsFinish" v-model="finishJam" @change="onCekJadwal" label="Jam"></v-select>
                </v-col>
                <v-col class="d-flex" cols="12" sm="12" v-if="jasaItems.length > 0">
                  <v-select prepend-icon="add_shopping_cart" :items="jasaItems" v-model="selectedJasa" label="Pilih Layanan"></v-select>
                </v-col>
                <v-col class="d-flex" cols="12" sm="12" v-else>
                  <p class="font-italic red--text caption">*Tidak ditemukan, silahkan cari jadwal lain.</p>
                </v-col>
              </v-row>
              <v-btn type="submit" color="primary" v-if="jasaItems.length > 0 && selectedJasa" class="mr-4">
                Book
              </v-btn>
            </v-form>
          </v-container>
        </v-card>
      </v-dialog>

      <v-sheet height="600">
        <v-calendar
          ref="calendar"
          v-model="focus"
          color="primary"
          :events="events"
          :event-color="getEventColor"
          :event-margin-bottom="3"
          :now="today"
          :type="type"
          :interval-time-format="true"
          @click:event="showEvent"
          @click:more="viewDay"
          @click:date="viewDay"
          @change="updateRange"
        ></v-calendar>
        <v-menu
          v-model="selectedOpen"
          :close-on-content-click="false"
          :activator="selectedElement"
          full-width
          offset-x
        >
          <v-card color="grey lighten-4" min-width="350px" flat>
            <v-toolbar :color="selectedEvent.color" dark>
              <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
              <div class="flex-grow-1"></div>
            </v-toolbar>
            <v-card-text>
              <form v-if="currentlyEditing !== selectedEvent.id">
                {{ selectedEvent.details }}
             </form>
              <form v-else>
                <textarea-autosize
                  v-model="selectedEvent.details"
                  type="text"
                  style="width: 100%"
                  :min-height="100"
                  placeholder="add note">
                </textarea-autosize>
              </form>
            </v-card-text>
            <v-card-actions>
              <v-btn text color="secondary" @click="selectedOpen = false">
                close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex"
import { forEach, remove, find } from "lodash"
import moment from 'moment';
export default {
    data: () => ({
      today: new Date().toISOString().substr(0, 10),
      focus: new Date().toISOString().substr(0, 10),
      type: 'month',
      menu: false,
      menuFinish: false,
      typeToLabel: {
        month: 'Month',
        week: 'Week',
        day: 'Day'
      },
      jamItemsStart: [],
      jamItemsFinish: [],
      startJam: null,
      finishJam: null,
      inputStart: null,
      inputEnd: null,
      name: null,
      details: null,
      start: null,
      end: null,
      color: '#1976D2', // default event color
      currentlyEditing: null,
      selectedEvent: {},
      selectedElement: null,
      selectedJasa: null,
      selectedOpen: false,
      dialog: false,
      available: [],
      jasaItems: [],
      dataJadwal: null
    }),
    mounted () {
      const month = moment().format('YYYY-MM-DD')
      this.getEvents(month)
      // this.getProductJasa()
      
      for (let i = 0; i < 24; i++) {
        this.jamItemsStart.push({
          text: i.toString().length == 1 ? '0' + i + ':00' : i + ':00',
          value: i.toString().length == 1 ? '0' + i + ':00:01' : i + ':00:01'
        })

        this.jamItemsFinish.push({
          text: i.toString().length == 1 ? '0' + i + ':00' : i + ':00',
          value: i.toString().length == 1 ? '0' + i + ':00:00' : i + ':00:00'
        })
      }
    },
    computed: {
      ...mapState({
        events: state => state.jadwal.events,
        productJasa: state => state.jadwal.productJasa,
        allProductJasa: state => state.jadwal.allProductJasa,
        listPesanan: state => state.products.listPesanan,
      }),
      title () {
        const { start, end } = this
        if (!start || !end) {
          return ''
        }
        const startMonth = this.monthFormatter(start)
        const endMonth = this.monthFormatter(end)
        const suffixMonth = startMonth === endMonth ? '' : endMonth
        const startYear = start.year
        const endYear = end.year
        const suffixYear = startYear === endYear ? '' : endYear
        const startDay = start.day + this.nth(start.day)
        const endDay = end.day + this.nth(end.day)
        switch (this.type) {
          case 'month':
            return `${startMonth} ${startYear}`
          case 'week':
            return `${startMonth} ${startDay} ${startYear} - ${suffixMonth} ${endDay} ${suffixYear}`
          case 'day':
            return `${startMonth} ${startDay} ${startYear}`
        }
        return ''
      },
      monthFormatter () {
        return this.$refs.calendar.getFormatter({
          timeZone: 'UTC', month: 'long',
        })
      },
    },
    methods: {
      ...mapMutations({
        setListPesanan : "products/SET_LIST_PESANAN",
        setProductJasa : "jadwal/SET_PRODUCT_JASA",
      }),
      ...mapActions({
        getEvents: "jadwal/getEvents",
        getProductJasa: "jadwal/getProductJasa",
        cekJadwal: "jadwal/cekJadwal",
        calculateTotal: "products/calculateTotal"
      }),
      viewDay ({ date }) {
        this.focus = date
        this.type = 'day'
      },
      getEventColor (event) {
        return event.color
      },
      setToday () {
        this.focus = this.today
        if(this.type === 'month'){
          this.getEvents(this.focus)
        }
      },
      prev () {
        this.$refs.calendar.prev()
        if(this.type === 'month'){
          this.getEvents(this.focus)
        }
      },
      next () {
        this.$refs.calendar.next()
        if(this.type === 'month'){
          this.getEvents(this.focus)
        }
      },
      async onCekJadwal(){
        let d1 = new Date(this.inputStart + " " + this.startJam.replace(":01", ":00"));
        let d2 = new Date(this.inputEnd + " " + this.finishJam);
        let greaterThanDate = d1.getTime() > d2.getTime();
        if(!greaterThanDate){
          this.getProductJasa()
          this.jasaItems = [];
          let available = this.productJasa
          if (this.inputStart && this.inputEnd && this.startJam && this.finishJam && (this.inputStart + " " + this.startJam.replace(":01", ":00") != this.inputEnd + " " + this.finishJam)) {
            const payload = {
                from: this.inputStart + " " + this.startJam,
                to: this.inputEnd + " " + this.finishJam
            }
            const response = await this.cekJadwal(payload)

            forEach(response.data.attributes, data => {
              remove(available, function(currentObject) {
                  return currentObject.value === data.product_id;
              });
            })

            forEach(available, ava => {
              this.jasaItems.push(ava)
            })
          }else{
            this.jasaItems = []
          } 
        }else{
          this.jasaItems = [];          
        }
      },
      async addEvent () {
          const selectedProduct = find(this.allProductJasa, jasa => jasa.id == this.selectedJasa)

          const start = new Date(this.inputStart+' '+this.startJam)
          const end = new Date(this.inputEnd+' '+this.finishJam)

          let currentPesanan = this.listPesanan
          const itemPesanan = {
              product_id: selectedProduct.id,
              item_name: selectedProduct.name,
              harga_jual: Number(selectedProduct.harga_jual),
              qty: (end - start + 1000)/3600000,
              discount: 0,
              ppn: 0,
              stock: (end - start + 1000)/3600000,
              mulai: this.inputStart+' '+this.startJam,
              selesai: this.inputEnd+' '+this.finishJam
          }

          currentPesanan.push(itemPesanan)

          this.setListPesanan(currentPesanan)
          this.calculateTotal()

          this.dialog = false
          this.inputStart = null
          this.inputEnd = null
          this.startJam = null
          this.finishJam = null
          this.selectedJasa = null
      },
      editEvent (ev) {
        this.currentlyEditing = ev.id
      },
      updateEvent (ev) {
        this.currentlyEditing = null
      },
      showEvent ({ nativeEvent, event }) {
        const open = () => {
          this.selectedEvent = event
          this.selectedElement = nativeEvent.target
          setTimeout(() => this.selectedOpen = true, 10)
        }
        if (this.selectedOpen) {
          this.selectedOpen = false
          setTimeout(open, 10)
        } else {
          open()
        }
        nativeEvent.stopPropagation()
      },
      updateRange ({ start, end }) {
        this.start = start
        this.end = end
      },
      nth (d) {
        return d > 3 && d < 21
          ? 'th'
          : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][d % 10]
      },
    },
}
</script>